import { RenderedServiceData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export interface RenderedServiceListFilterParams {
    ehrId?: string;
}

export class RenderedServiceList extends SimpleList<RenderedServiceData, RenderedServiceListFilterParams> {
    protected filterValue(value: RenderedServiceData, filterParams: RenderedServiceListFilterParams): boolean {
        return this.filterFieldValue(value, filterParams.ehrId, 'ehrId');
    }
}
